import {where,groupBy,pluck,find,contains,filter} from 'underscore';
import $ from "jquery";
import { COVID_SUSPECT_VALIDATION } from '../../../constants/Constants';
import {getSelectedOptions} from "./GeneralFractureValidation"

export const validateCovidSuspectAnnotation = (inputObj, annotations, groups, validationData) => {
	var selectedData = null;
	
	var annotationIdChk = contains(annotations, 56);
	
	if(!annotationIdChk) {
		return null;
	}
	
	if( groups[56] != undefined && groups[56].length > 1) {
		return {error:1, message:COVID_SUSPECT_VALIDATION._iOneCovidTtemplate};
	}
	selectedData = getSelectedOptions(inputObj, validationData);
	
	if((groups[56] != undefined && groups[56].length == 1) && selectedData.length == 0) {
		return {error:1, message:COVID_SUSPECT_VALIDATION._iOneCovidTtemplate};
	}
	
	
	var result = validateCovidSuspectGroups(selectedData);
	if(result != null) {
		return result;
	}
	
//	result = validateCVCX1(selectedData);
//	if(result != null) {
//		return result;
//	}
	
//	result = validateCVCX2(selectedData);
//	if(result != null) {
//		return result;
//	}
	
	result = validateCVCX3(selectedData);
	if(result != null) {
		return result;
	}
	
	return null;
}

function validateCovidSuspectGroups(selectedData) {
	var groupData = groupBy(selectedData, function(o){return o.groupNumber});
	if(groupData && Object.keys(groupData).length > 1) {
		return {error:1, message:COVID_SUSPECT_VALIDATION._iOneCovidTtemplate};
	}
	return null;
}

function validateCVCX1(selectedData) {
	var data = where(selectedData, {groupNumber:2});
	if(data.length > 1) {
		return {error:1, message:COVID_SUSPECT_VALIDATION._iOneOptionCVCX1};
	}
	return null;
}

function validateCVCX2(selectedData) {
	var data = where(selectedData, {groupNumber:3});
	if(data.length < 2) {
		return {error:1, message:COVID_SUSPECT_VALIDATION._iOneSuboptionCVCX2};
	}
	return null;
}

function validateCVCX3(selectedData) {
	var groupData = where(selectedData, {groupNumber:4});
	
	var group1 = [131197
		,131198
		,131199];
	var group2 = [131200
		,131201
		,131202];
	
	var g1 = filter(groupData, function(o) {return contains(group1, o.optionAssetId)});
	var g2 = filter(groupData, function(o) {return contains(group2, o.optionAssetId)});
	
	var g11 = groupBy(g1, function(o){return o.optionAssetId});
	var g22 = groupBy(g2, function(o){return o.optionAssetId});
	
	if(Object.keys(g11).length > 1) {
		return {error:1, message:COVID_SUSPECT_VALIDATION._iOneOptionCVCX3Pneumothorax}
	}
	
	if(Object.keys(g22).length > 1) {
		return {error:1, message:COVID_SUSPECT_VALIDATION._iOneOptionCVCX3PleuralEffusion}
	}
	
	return null;
	
}
